// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decisions_references-module__refComments--3b57g{display:inline-block;color:#02b875}\n", ""]);
// Exports
exports.locals = {
	"refComments": "decisions_references-module__refComments--3b57g"
};
module.exports = exports;
